<template>
  <div class="card-container foundermanage">
    <j-h-select></j-h-select>
    <h-l-f-select></h-l-f-select>
    <w-t-x-select></w-t-x-select>
  </div>
</template>

<script>
import JHSelect from "@/view/fragment/select/JHSelect";
import HLFSelect from "@/view/fragment/select/HLFSelect";
import WTXSelect from "@/view/fragment/select/WTXSelect";
import { loadMixin, dialogMixin } from "mixin";
import { mapGetters } from "vuex";

export default {
  name: "selectmanage",
  data() {
    return {};
  },
  mixins: [loadMixin, dialogMixin],
  components: {
    JHSelect,
    HLFSelect,
    WTXSelect,
  },
  created() {},
  mounted() {},
  computed: {
    // ...mapGetters(["userId", "tatId", "orgDetail"]),
  },
  methods: {},
};
</script>

<style scoped>
.box-card .label {
  width: 180px;
  text-align: right;
  vertical-align: middle;
  float: left;
  font-size: 14px;
  color: #606266;
  line-height: 40px;
  padding: 0 12px 0 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/view/page/SystemManage/SelectManage.vue